import { GanttLinks } from '@/ship/Enums/GanttEnum';
import { IPMChart, IPMChartVersionRow } from '@/ship/Models/IProjectManagement';
import { Link, Structure } from '@/ship/Models/ProjectManagement';
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import {
    ProjectManagementAction,
    ProjectManagementGetter,
    ProjectManagementState,
} from '@/store/ProjectManagement/ProjectManagementRoot';
import ErrorService from '@/utils/ErrorService';
import { fromISODateToLocal } from '@/utils/Helper';
import { Vue } from 'vue-property-decorator';

export default class PMDynamicTableMixin extends Vue {
    @ProjectManagementState chart!: IPMChart;

    @ProjectManagementAction GET_CHART_BY_ID!: (params: { id: number; params?: GetRequestParams }) => Promise<IPMChart>;

    @ProjectManagementGetter isStructureExist!: boolean;
    @ProjectManagementGetter chartVersions!: IPMChartVersionRow[];

    onTop: boolean = true;
    isConnectionOverflowed = false;

    formatDate(date: string) {
        const _date = fromISODateToLocal(date);
        return _date.length ? _date : '-';
    }

    getConnectionType(type: Link['type']) {
        switch (type) {
            case GanttLinks.EndEnd:
                return 'ОО';
            case GanttLinks.StartEnd:
                return 'НО';
            case GanttLinks.StartStart:
                return 'НН';
            default:
                return '';
        }
    }

    getConnectionHtml(structure: Structure) {
        if (!structure.links?.data?.length) {
            return '-';
        }

        const links = structure.links.data;
        let resultHtml = '';

        const trialElement = document.createElement('div');
        trialElement.className = 'truncate-text';
        document.body.appendChild(trialElement);

        let fullFit = true;
        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            const label = link.targetTaskCode;
            const suffix = this.getConnectionType(link.type);

            const baseTitle = link.delay ? `${label}${suffix}(${link.delay})` : `${label}${suffix}`;

            const displayText =
                link.targetChartId !== this.chartId ? `<span class="other-chart">${baseTitle}</span>` : baseTitle;

            const trialText = resultHtml + displayText + ', ';
            trialElement.innerHTML = trialText;

            const columnWidth = 136;
            trialElement.style.width = `${columnWidth}px`;

            if (trialElement.scrollWidth > trialElement.clientWidth) {
                fullFit = false;
                this.isConnectionOverflowed = true;
                resultHtml = resultHtml.trim().replace(/,\s*$/, '') + '...';
                break;
            }

            resultHtml = trialText;
        }

        document.body.removeChild(trialElement);

        if (fullFit) {
            this.isConnectionOverflowed = false;
            resultHtml = resultHtml.trim().replace(/,\s*$/, '');
        }

        return resultHtml.length ? resultHtml : '-';
    }

    get chartId(): number {
        return this.getIdFromParams(this.$route.params.id);
    }

    getIdFromParams(paramsId: string | undefined): number {
        return paramsId ? parseInt(paramsId) : NaN;
    }

    async loadChart() {
        if (!this.chartId) return;
        const params: GetRequestParams = {
            include: 'versions',
        };

        try {
            await this.GET_CHART_BY_ID({ id: this.chartId, params });
        } catch (error) {
            ErrorService.handleApiError(error);
        }
    }
}
